export const environment = (window as any)['__env'] || {};


